import { useNavigate } from "react-router-dom";
import { useState } from "react";
import {
    Button,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchBar from "../../../components/SearchBar";
import SwitchToggle from "../../../components/SwitchToggle";
import AddQuantity from "../../../Modals/addquantity";
const ManageFlavorQuantity = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const handleCloseModal = () => {
        setOpenModal(false);
    };
    // Example data (replace with API later)
    const [quantities, setQuantities] = useState([
        { id: 1, quantity: 100,size:"Small", price: 2.5, status: true },
        { id: 2, quantity: 200,size:"Medium", price: 4.0, status: true },
        { id: 3, quantity: 300,size:"Large", price: 5.5, status: false },
        { id: 4, quantity: 500,size:"Extra large", price: 8.0, status: true },
    ]);

    return (
        <>
            <div className="main_title">
                <h1>Manage Quantities</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
                    <button onClick={() => navigate("/manage-flavour/")}>Manage Flavour</button> - Manage Quantities
                </p>
            </div>

            <div className="cards">
                <div className="table_header">
                    <div className="left_s">
                        <SearchBar
                            searchTerm={searchTerm}
                            setDebouncedSearchTerm={setSearchTerm}
                            placeholder="Search Quantities..."
                        />
                    </div>
                    <div className="right_s">
                        <Button
                            className="btn btn_primary"
                            onClick={() => setOpenModal(true)}
                        >
                            <AddIcon /> Add Quantity
                        </Button>
                    </div>
                </div>

                {/* Quantity Table */}
                <div className="custom_table_wrapper">
                    <Table className="custom_table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Sr. No</TableCell>
                                <TableCell>Size</TableCell>
                                <TableCell>Quantity (ml)</TableCell>
                                <TableCell>Price ($)</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {quantities
                                .filter((q) =>
                                    q.quantity.toString().includes(searchTerm.toLowerCase())
                                )
                                .map((item, index) => (
                                    <TableRow key={item.id}>
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell>{item.size}</TableCell>
                                        <TableCell>{item.quantity} ml</TableCell>
                                        <TableCell>${item.price.toFixed(2)}</TableCell>
                                        <TableCell>
                                            <SwitchToggle />
                                        </TableCell>
                                        <TableCell>
                                            <div className="table_actions v2">
                                                <IconButton
                                                    onClick={() => setOpenModal(true)}
                                                >
                                                    <img src="/static/images/edit2_icon.svg" alt="Edit" />
                                                </IconButton>
                                                <IconButton

                                                >
                                                    <img src="/static/images/trash2_icon.svg" alt="Delete" />
                                                </IconButton>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                </div>
            </div>
            <AddQuantity
                open={openModal}
                onClose={handleCloseModal}
                setOpen={setOpenModal}
            />
        </>
    );
};

export default ManageFlavorQuantity;
